const formatter = options => Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  ...options
})

const defaultFormatter = formatter()

/**
 * Format a number as currency.
 * @param {String} input
 * @param {Object} options - Optional configuration for `toLocaleString`
 */
export default (input, options) => {
  if (isNaN(Number(input))) return input
  if (!options) {
    return defaultFormatter.format(input)
  }

  let digitsValue
  if (options.digits === true) {
    digitsValue = (input % 1) ? 2 : 0
  } else {
    digitsValue = Number(options.digits) || 0
  }
  options.digits = digitsValue

  return formatter({
    maximumFractionDigits: options.digits,
    minimumFractionDigits: options.digits,
    ...options
  }).format(input)
}
